// extracted by mini-css-extract-plugin
export default {"container":"Monitor_container__rci+R","boxes":"Monitor_boxes__i2KCv"};